import React from 'react';
import HeaderPayment from './payment';
import { locationPath } from '../../helpers/locationHelper';

const Header = (props) => {
  return (
    <div className={`header ${locationPath()}`}>
      <div className="row">
        <div className="column small-12">
              <div className="row">
                <div className="column small-6">
                    <a href="https://www.busabout.com">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 186.81 26.58" className="logo">
                      <g>
                          <path d="M4.32 4.37h-.78L0 25.49h12.45c6.51 0 8.87-3.91 8.87-6.53a5.54 5.54 0 0 0-3.13-4.87 5.07 5.07 0 0 0 2.16-4.14c0-1.31-.63-5.58-8.65-5.57zm7 5c1.07 0 2.35.17 2.35 1 0 1.19-1.49 1.37-2.38 1.37H9.07l.44-2.4h1.82M11 16.88c.8 0 3.4.11 3.4 1.62s-1.74 1.91-3.19 1.91H7.59l.64-3.53H11M45.91 10.78c0 3.38 3.06 4.94 5.51 6.19 1.56.8 3 1.56 3 2.41s-1 1.2-2.41 1.2A13.6 13.6 0 0 1 46 18.75l-1.1-.66-1.2 5.29.61.33a16.76 16.76 0 0 0 8.33 1.93c6 0 8.77-3.55 8.77-6.84 0-3.72-3.38-5.38-5.84-6.6-1.27-.63-2.71-1.34-2.71-1.92s1.05-1.2 2.34-1.2a11.91 11.91 0 0 1 5.27 1.55l1.12.67 1.07-5.37-.66-.3A16.22 16.22 0 0 0 55 4c-5.18 0-9.08 2.92-9.07 6.76M44.91 4.38H39.2l-2.08 12.45c-.51 3.07-3.29 3.53-4.9 3.54a3.78 3.78 0 0 1-2.87-1 3.65 3.65 0 0 1-.46-3l2-12h-6.8l-2 11.73c-.48 2.79 0 5 1.35 6.67 1.66 2 4.61 3 8.77 2.95 8.43 0 10.95-4.53 11.57-8.31L46 4.38zM94.66 1.13L86.19 6.6l6.27 5H88l-2.25 13.73H98.2c6.52 0 8.87-3.91 8.87-6.53a5.54 5.54 0 0 0-3.12-4.87 5.07 5.07 0 0 0 2.16-4.14c0-1.31-.63-5.58-8.65-5.57h-1.7L96.37 0zm0 10.51l.35-2.39h2.07c1.08 0 2.35.17 2.36 1 0 1.19-1.49 1.37-2.38 1.37h-2.4zm2.07 5.08c.8 0 3.4.11 3.4 1.62s-1.74 1.91-3.19 1.91h-3.6l.66-3.53h2.74M178.35 1.59L178 4h-16.15L161 9.14h7.35l-2.69 16.06h6.8l2.69-16.06h2.1l-.61 4.09 10.18-6.58L178.58 0z"/>
                          <path d="M80.66 4H74l-8.38 12.46h-4.16L64 26.58l12.69-9.68L78 25.34h6.94L81.45 4zm-4.84 7.3c.2 1.29.4 2.62.81 5.24h-4.39l3.58-5.23M142.6.87l-8.86 8.41 4.34-.06-1.15 6.71a12.05 12.05 0 0 0-.19 2.07c0 3.45 1.8 7.57 10.31 7.56S158 21 158.63 17.25l2.2-13.09H154l-2.08 12.44c-.51 3.07-3.29 3.53-4.9 3.54a3.78 3.78 0 0 1-2.87-1 2.81 2.81 0 0 1-.56-1.87 6.7 6.7 0 0 1 .1-1.14l1.19-7h4.74l-6.26-9z"/>
                          <path d="M120.32 4l-.85.1.24 5.5 1-.19a8.74 8.74 0 0 1 1.51-.14c3.33 0 5.75 1.92 5.75 4.58 0 3.5-3.2 6.23-7.3 6.24-3.42 0-5.72-1.87-5.72-4.67a5.13 5.13 0 0 1 .43-2l3 1.46-.64-10.52-11.28 4.5 3 1.49a10.4 10.4 0 0 0-1.46 5.31c0 5.72 5.32 9.87 12.64 9.86 8.41 0 14.28-4.93 14.27-11.94 0-5.72-5.1-9.7-12.37-9.69a20 20 0 0 0-2.26.13"/>
                        </g>
                      </svg>

                    </a>
                </div>
                <div className="column small-6">
                    <HeaderPayment location={locationPath()}/>
                </div>
              </div>
          </div>
      </div>
    </div>
  )
}

export default React.memo(Header);



// WEBPACK FOOTER //
// ./src/components/shared/header.js